import { Provider } from "react-redux";
import "./App.css";
import AppRouter from "./router/AppRouter";
import store, { persistor } from "./redux/app/store";
import { PersistGate } from "redux-persist/integration/react";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRouter />
      </PersistGate>
    </Provider>
  );
}

export default App;
